import React, { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";

const NewsletterSignup = ({ variant = "light" }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email });
      toast.success(data.message || "Subscribed successfully.");
      setEmail("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Could not subscribe.");
    } finally {
      setLoading(false);
    }
  };

  const isDark = variant === "dark";

  return (
    <form onSubmit={submit} data-testid="newsletter-form" className="w-full max-w-md">
      <div
        className={`flex items-center gap-2 rounded-full border p-1.5 ${
          isDark ? "border-white/25 bg-white/5" : "border-slate-300 bg-white"
        }`}
      >
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Your email address"
          data-testid="newsletter-email-input"
          className={`flex-1 bg-transparent px-4 py-2 text-sm outline-none ${
            isDark ? "text-white placeholder:text-white/50" : "text-navy placeholder:text-slate-400"
          }`}
        />
        <button
          type="submit"
          disabled={loading}
          data-testid="newsletter-submit"
          className="flex items-center gap-2 rounded-full bg-gold px-5 py-2 text-sm font-semibold text-navy transition-colors duration-300 hover:bg-gold-bright disabled:opacity-60"
        >
          {loading ? "..." : "Subscribe"}
          <ArrowRight size={16} />
        </button>
      </div>
    </form>
  );
};

export default NewsletterSignup;
